import $ from 'jquery';
/* ===============================================================
Navbar dropdown
=============================================================== */
class NavbarDropdown {
    constructor() {
        this.btnToggle = $('.irantheme-navbar-trigger');
        this.dropdown = $('.irantheme-navbar-dropdown');
        this.menuParentsLink = this.dropdown.find(
            '.irantheme-navbar-dropdown-menu-ul .menu-item-has-children > a'
        );
        this.$window = $(window);
        this.$document = $(document);

        // Cache frequently used elements
        this.$inputElements = $('input, textarea');
        this.isOpen = false;
        this.resizeTimer = null;

        // Early return if no elements exist
        if (!this.btnToggle.length || !this.dropdown.length) return;

        this.events();
    }

    events() {
        // Single click handler with event delegation
        this.btnToggle.on('click', (e) => {
            e.preventDefault();
            if (this.isTriggerMobile()) {
                this.toggle();
            }
        });

        // Keyboard navigation with throttling
        this.$document.on('keydown', (e) => {
            if (this.isTriggerMobile()) {
                this.handleKeyPress(e);
            }
        });

        // Menu parent links with event delegation
        this.dropdown.on(
            'click',
            '.irantheme-navbar-dropdown-menu-ul .menu-item-has-children > a',
            (e) => {
                e.preventDefault();
                this.toggleMenu(e);
            }
        );

        // Debounced resize handler
        this.$window.on('resize', () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.closeDropdownOnDesktop();
            }, 100);
        });
    }

    toggle() {
        this.btnToggle.toggleClass('active');
        this.dropdown.stop(true, true).slideToggle(600);
        this.isOpen = !this.isOpen;
    }

    open() {
        if (this.isOpen) return;

        this.btnToggle.addClass('active');
        this.dropdown.stop(true, true).slideDown(600);
        this.isOpen = true;
    }

    close() {
        if (!this.isOpen) return;

        this.btnToggle.removeClass('active');
        this.dropdown.stop(true, true).slideUp(600, () => {
            // Cleanup after animation completes
            this.menuParentsLink.removeClass('active');
            this.menuParentsLink.siblings('.sub-menu').slideUp(250);
        });
        this.isOpen = false;
    }

    handleKeyPress(e) {
        // Early return if input is focused
        if (this.$inputElements.is(':focus')) return;

        const key = e.keyCode || e.which;

        switch (key) {
            case 77: // 'M' key
                if (!this.isOpen) this.open();
                break;
            case 27: // Escape key
                if (this.isOpen) this.close();
                break;
        }
    }

    toggleMenu(e) {
        const $target = $(e.currentTarget);
        const $siblings = $target.parent().siblings('.menu-item');

        if ($target.hasClass('active')) {
            // Close current menu
            $target.removeClass('active');
            $target.siblings('.sub-menu').slideUp(250);
        } else {
            // Close sibling menus first
            this.closeSiblingMenus($target, $siblings);

            // Open current menu
            $target.addClass('active');
            $target.siblings('.sub-menu').slideDown(250);
        }
    }

    closeSiblingMenus($current, $siblings) {
        // Check if any parent links are active
        const hasActiveParent = this.menuParentsLink.hasClass('active');

        if (!hasActiveParent) {
            // Close all menus
            this.menuParentsLink.removeClass('active');
            this.menuParentsLink.siblings('.sub-menu').slideUp(250);
        } else {
            // Close only sibling menus
            $siblings.children('.menu-item-link').removeClass('active');
            $siblings.children('.sub-menu').slideUp(250);
        }
    }

    isTriggerMobile() {
        const mobileTriggerMode = this.btnToggle
            .parent()
            .data('trigger-mobile');
        const windowWidth = this.$window.outerWidth();

        return mobileTriggerMode === 'dropdown' && windowWidth < 1200;
    }

    closeDropdownOnDesktop() {
        if (this.$window.outerWidth() >= 1200 && this.isOpen) {
            this.close();
        }
    }
}

export default NavbarDropdown;
